<template>
    <div>
        <ubi-panel>
            <el-container>
                <el-aside width="25%"><h3>{{ $t("posts.edit.saleRentalTitle") }}</h3>
                    <p class="text-justify">{{ $t("posts.edit.fillAdPriceDetails") }}</p></el-aside>
                <el-container>
                    <el-main>
                        <el-col :span="24">
                            <h4>{{ $t("posts.edit.saleTitleShort") }}</h4>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.prix"
                                          prop="prix"
                                          >
                                <el-input   v-mask="'#################'" v-model.number="post.prix" type="prix">
                                    <div slot="append">{{getDevise}}</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.afficher_prix"  icon="el-icon-question">
                                <el-radio v-model="post.afficher_prix" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.afficher_prix" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.prix_vendu_net"
                                          prop="prix_vendu_net"
                                          >
                                <el-input   v-mask="'#################'" v-model.number="post.prix_vendu_net" type="prix_net_vendeur">
                                    <div slot="append">{{getDevise}}</div>
                                </el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.costsWillBeBorneBy')">
                                <el-select
                                        v-model="post.honoraires_payeurs"
                                        :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                        clearable
                                        filterable
                                >
                                    <el-option
                                            style="text-transform:capitalize"
                                            v-for="choice in this.$parent.getChoices('honoraires_payeurs')"
                                            :key="choice"
                                            :label="choice"
                                            :value="choice"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="showSellerShare">
                            <el-col :md="8" :xs="24">
                                <el-form-item>
                                    <div >
                                        {{ $t("posts.edit.sellerShare") }} :
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :md="7" :xs="24">
                                <el-form-item
                                        prop="prix_honoraire_vendeur"
                                        >
                                    <el-input   v-mask="'#################'" v-model.number="post.honoraires_negociation_vendeur"
                                              type="honoraires_negociation_vendeur">
                                        <div slot="append">{{getDevise}}</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :md="2">&nbsp;</el-col>
                            <el-col :md="7" :xs="24">
                                <el-form-item
                                        prop="pourcentage_honoraires_vendeur"
                                        >
                                    <el-input   v-mask="'#################'" v-model.number="post.pourcentage_honoraires_vendeur" type="pourcentage_honoraires_vendeur">
                                        <div slot="append">%</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-col >
                        <el-col :span="24" v-if="showBuyerShare">
                            <el-col :md="8" :xs="24">
                                <el-form-item>
                                    <div >
                                        {{ $t("posts.edit.buyerShare") }} :
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :md="7" :xs="24">
                                <el-form-item
                                        prop="honoraires_negociation"
                                        >
                                    <el-input v-mask="'#################'" v-model.number="post.honoraires_negociation"
                                              type="honoraires_negociation">
                                        <div slot="append">{{getDevise}}</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :md="2">&nbsp;</el-col>
                            <el-col :md="7" :xs="24">
                                <el-form-item
                                        prop="alur_pourcentage_honoraires_ttc"
                                        >
                                    <el-input type="number" v-model="post.alur_pourcentage_honoraires_ttc" step="0.01">
                                        <div slot="append">%</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-col >
                        <el-col :span="24">
                            <el-form-item :label="$labels.taxe_fonciere"
                                          prop="taxe_fonciere"
                                          >
                                <el-input   v-mask="'#################'" v-model.number="post.taxe_fonciere" type="taxe_fonciere">
                                    <div slot="append">{{getDevise}}</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.linkToAgencyFees')">
                                <el-input v-model="post.url_tarifs_publics">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                          <div class="block">
                            <el-form-item :label="$labels.frais_notaire" prop="frais_notaire">
                              <el-input   v-mask="'#################'" v-model.number="post.frais_notaire" type="frais_notaire" style="width: 50%">
                                <div slot="append">{{ getDevise }}</div>
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <div class="block">
                            <el-form-item :label="$labels.taux_tva" prop="taux_tva">
                              <el-input v-model="post.taux_tva" type="number" step="0.01" />
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.pour_investisseur">
                                <el-radio v-model="post.pour_investisseur" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.pour_investisseur" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <hr>
                        </el-col>
                        <el-col :span="24">
                            <h4>Location</h4>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.loyer_mensuel"
                                          prop="loyer_mensuel"
                                          >
                                <el-input
                                    type="text"
                                    inputmode="decimal"
                                    autocomplete="off"
                                    :value="montantDisplay('loyer_mensuel')"
                                    @focus="() => onMontantFieldFocus('loyer_mensuel')"
                                    @input="v => onMontantTextInput('loyer_mensuel', v)"
                                    @blur="() => onMontantFieldBlur('loyer_mensuel')"
                                    clearable>
                                    <div slot="append">{{getDevise}} / {{ $t("general.month") }}</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.complement_loyer + ' ' + $t('posts.edit.includingTaxes')"
                                          prop="complement_loyer"
                                          >
                                <el-input
                                    type="text"
                                    inputmode="decimal"
                                    autocomplete="off"
                                    :value="montantDisplay('complement_loyer')"
                                    @focus="() => onMontantFieldFocus('complement_loyer')"
                                    @input="v => onMontantTextInput('complement_loyer', v)"
                                    @blur="() => onMontantFieldBlur('complement_loyer')"
                                    clearable>
                                    <div slot="append">{{getDevise}} / {{ $t("general.month") }}</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                          <el-form-item :label="$labels.charges_locatives">
                            <el-input
                                type="text"
                                inputmode="decimal"
                                autocomplete="off"
                                :value="montantDisplay('charges_locatives')"
                                @focus="() => onMontantFieldFocus('charges_locatives')"
                                @input="v => onMontantTextInput('charges_locatives', v)"
                                @blur="() => onMontantFieldBlur('charges_locatives')"
                                clearable>
                              <template slot="append">{{getDevise}} / {{ $t("general.month") }}</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.recoveryCondition')">
                                <el-select
                                        v-model="post.modalites_recuperation_charges_locatives"
                                        :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                        clearable
                                        filterable
                                >
                                    <el-option
                                            style="text-transform:capitalize"
                                            v-for="modaliteRecuperationChoice in this.$parent.getChoices('modalites_recuperation_charges_locatives')"
                                            :key="modaliteRecuperationChoice"
                                            :label="modaliteRecuperationChoice"
                                            :value="modaliteRecuperationChoice"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.rentalFeeIncludingConditionInspection')"
                                          >
                                <el-input v-model="post.honoraires_etat_des_lieux" step="0.01" type="number">
                                    <div slot="append">{{getDevise}}</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.honoraires_etat_des_lieux + ' ' + $t('posts.edit.includingTaxes')"
                                          >
                                <el-input v-model="post.honoraire_ttc" step="0.01" type="number">
                                    <div slot="append">{{getDevise}}</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                          <el-form-item :label="$t('posts.securityDeposit')">
                            <el-input
                                type="number"
                                step="0.01"
                                v-model="post.depot_garantie"
                                clearable>
                              <template slot="append">{{getDevise}}</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.linkToAgencyFees')">
                                <el-input v-model="post.url_tarifs_publics">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.duree_du_bail"
                                          prop="duree_du_bail"
                                          >
                                <el-input   v-mask="'#################'" v-model.number="post.duree_du_bail" type="duree_du_bail">
                                    <div slot="append">mois</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.collateralSecurityRequired')">
                                <el-radio v-model="post.organisme_foncier_solidaire" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.organisme_foncier_solidaire" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.organisme_foncier_solidaire == 'oui'">
                            <el-form-item :label="$labels.montant_caution_solidaire"
                                          prop="montant_caution_solidaire"
                                          >
                                <el-input   v-mask="'#################'" v-model.number="post.montant_caution_solidaire" type="montant_caution_solidaire">
                                    <div slot="append">{{getDevise}}</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <div class="block">
                                <el-form-item :label="$labels.date_disponibilite">
                                    <el-date-picker
                                            v-model="post.date_disponibilite"
                                            format="dd/MM/yyyy"
                                            value-format="dd/MM/yyyy">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.pour_investisseur">
                                <el-radio v-model="post.pour_investisseur" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.pour_investisseur" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>
        <ubi-panel>
            <el-container>
                <el-aside width="25%"><h3>{{ $t("posts.edit.copropertyTitle") }}</h3>
                    <p class="text-justify">{{ $t("posts.edit.fillCopropertyInformation") }}</p>
                </el-aside>
                <el-container>
                    <el-main>
                        <el-col :span="24">
                            <el-form-item :label="$labels.copropriete">
                                <el-radio v-model="post.copropriete" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.copropriete" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="(isBailleurSocial || isAgence) && post.copropriete === 'oui'">
                          <el-form-item :label="$labels.alur_syndic_en_procedure" >
                            <el-radio v-model="post.alur_syndic_en_procedure" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.alur_syndic_en_procedure" label="non">{{ $t("general.no") }}</el-radio>
                          </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.copropriete == 'oui' ">
                            <el-form-item :label="$labels.alur_nb_lots">
                                <el-input v-model="post.alur_nb_lots">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.copropriete == 'oui' ">
                            <el-form-item :label="$t('posts.edit.copropertyMonthlyFee')">
                                <el-input v-model="post.charges_copropriete">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.copropriete == 'oui' ">
                            <el-form-item :label="$labels.alur_copropriete_plan_de_sauvegarde">
                                <el-radio v-model="post.alur_copropriete_plan_de_sauvegarde" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.alur_copropriete_plan_de_sauvegarde" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>
        <ubi-panel v-if="!isCmiste">
            <el-container>
                <el-aside width="25%"><h3>{{ $t("posts.edit.mandateTitle") }}</h3>
                    <p class="text-justify">{{ $t("posts.edit.fillMandateInformation") }}</p></el-aside>
                <el-container>
                    <el-main>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$labels.mandat_type">
                                    <el-radio-group v-model="post.mandat_type">
                                        <el-radio
                                                v-for="mandatTypeChoice in this.$parent.getChoices('mandat_type')"
                                                :key="mandatTypeChoice"
                                                :label="mandatTypeChoice"
                                                :value="mandatTypeChoice">
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item :label="$labels.mandat_statut">
                                    <div style="font-size: 12px;"><el-button class="el-icon-error reset-radio"
                                                                                              v-if="post.mandat_statut != '' && post.mandat_statut != undefined && post.mandat_statut != null"
                                                                                              @click="post.mandat_statut = null"
                                                                                              circle></el-button></div>
                                    <el-radio-group v-model="post.mandat_statut">
                                        <el-radio
                                                v-for="madantStatutChoice in this.$parent.getChoices('mandat_statut')"
                                                :label="madantStatutChoice"
                                                :value="madantStatutChoice">
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="post.mandat_statut=='vendu par l\'agence'">
                            <el-col lg="24">
                                <el-form-item :label="$labels.date_compromis">
                                    <el-date-picker
                                            v-model="post.date_compromis"
                                            format="dd/MM/yyyy"
                                            value-format="dd/MM/yyyy"
                                            :placeholder="$labels.date_compromis">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="block">
                                    <el-form-item :label="$labels.date_mandat">
                                        <el-date-picker
                                                v-model="post.date_mandat"
                                                format="dd/MM/yyyy"
                                                value-format="dd/MM/yyyy"
                                                :placeholder="$labels.date_mandat">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="block">
                                    <el-form-item :label="$labels.mandat_echeance">
                                        <el-date-picker
                                                v-model="post.mandat_echeance"
                                                format="dd/MM/yyyy"
                                                value-format="dd/MM/yyyy"
                                                :placeholder="$labels.mandat_echeance">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$labels.mandat_numero">
                                    <el-input v-model="post.mandat_numero">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item :label="$labels.vente_intercabinet">
                                    <el-checkbox
                                            v-model="post.vente_intercabinet" true-label="oui" false-label="non"></el-checkbox>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="post.vente_intercabinet =='oui' || post.intercabinet_repartition_honoraires != null">
                                <el-form-item :label="$t('posts.edit.intercabinetCommission')">
                                    <el-input   v-mask="'#################'" v-model.number="post.intercabinet_repartition_honoraires">
                                        <div slot="append">%</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$labels.proprietaire_nom + ' ' + $t('posts.edit.withoutCivilityAndName')">
                                    <el-input v-model="post.proprietaire_nom">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item :label="$labels.proprietaire_tel_dom">
                                    <el-input v-model="post.proprietaire_tel_dom">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$labels.proprietaire_tel_bur">
                                    <el-input v-model="post.proprietaire_tel_bur">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$t('posts.edit.landlordAddress')">
                                    <el-input v-model="post.proprietaire_adresse1">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item :label="$labels.proprietaire_code_postal">
                                    <el-autocomplete
                                            class="inline-input"
                                            v-model="post.proprietaire_code_postal"
                                            :fetch-suggestions="this.$parent.searchPostal"
                                            @select="this.$parent.selectPostalProprietaire"></el-autocomplete>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$labels.proprietaire_ville">
                                    <el-input v-model="post.proprietaire_ville">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :md="12" :xs="24">
                                <el-form-item :label="$t('posts.edit.realPropertyPostalCode')">
                                    <el-autocomplete
                                            class="inline-input"
                                            v-model="post.code_postal_reel"
                                            :fetch-suggestions="this.$parent.searchPostal"
                                            @select="this.$parent.selectPostalReel"></el-autocomplete>
                                </el-form-item>
                            </el-col>
                            <el-col :md="12" :xs="24">
                                <el-form-item :label="$t('posts.edit.realPropertyCity')">
                                    <el-input v-model="post.ville_reelle"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$t('posts.edit.landlordOtherInformation')">
                                    <el-input v-model="post.proprietaire_commentaire" type="textarea" :rows="5">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>

    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import { mapGetters } from 'vuex'
import montantDecimalInput from '@/mixins/montantDecimalInput'

export default {
  name: 'PostEditImmoOfferM',
  mixins: [montantDecimalInput],
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['isBailleurSocial', 'isAgence']),
    showBuyerShare () {
      return this.post.honoraires_payeurs && this.post.honoraires_payeurs.toLowerCase().indexOf(this.$t('posts.edit.buyer').toLowerCase()) !== -1
    },
    showSellerShare () {
      return this.post.honoraires_payeurs && this.post.honoraires_payeurs.toLowerCase().indexOf(this.$t('posts.edit.seller').toLowerCase()) !== -1
    },
    getDevise () {
      return this.$store.getters['donnees/getDevise']
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    userJob () {
      return this.sitimmoUser.metier
    },
    isCmiste () {
      return this.userJob === 'CMI'
    }
  },
  methods: {},
  async beforeMount () {
    let codes = ['modalites_recuperation_charges_locatives', 'mandat_statut', 'mandat_type', 'honoraires_payeurs']

    codes = codes.map(function (x) { return x.toUpperCase() })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>

<style>

</style>
